import styled from "styled-components";
import { Flex } from "@evergis/ui";

import { ColorContainer } from "../../SymbolEditor/styled";

export const AliasColorRow = styled(Flex)`
  align-items: flex-end;

  ${ColorContainer} {
    margin-left: 1rem;
  }
`;
